import { AlertCircle, RefreshCw } from 'lucide-react';
import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { Alert, AlertDescription, AlertTitle } from 'src/components/ui/alert';
import { Button } from 'src/components/ui/button';
import { BrandSidebarWithHeader } from 'src/layouts/BrandSidebarWithHeader';

export function RootErrorFallback(): ReactElement {
  const { t } = useTranslation('errors');

  return (
    <BrandSidebarWithHeader>
      <div className='flex h-full w-full items-center justify-center p-4'>
        <Alert className='w-96' variant='destructive'>
          <AlertCircle className='h-4 w-4' />
          <AlertTitle>{t('An error occurred')}</AlertTitle>
          <AlertDescription className='flex items-center justify-between'>
            <span>{t('Please reload the page')}</span>
          </AlertDescription>
          <div className='mt-3'>
            <Button
              className='h-8 bg-transparent text-error-default'
              onClick={() => window.location.reload()}
              size='sm'
              variant='outline'
            >
              <RefreshCw className='mr-2 h-3 w-3' />
              {t('Reload')}
            </Button>
          </div>
        </Alert>
      </div>
    </BrandSidebarWithHeader>
  );
}
